import * as React from 'react'
import { useFormikContext } from 'formik'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import { TypeCommonFields } from '../Fields/TypeCommonFields'
import { SalesTeamSelect } from '@user/components/Leads/AddLeadPage/FormFields/SalesTeamSelect/SalesTeamSelect'
import { SalesFunnelSelect } from '@user/components/Leads/AddLeadPage/FormFields/SalesFunnelSelect/SalesFunnelSelect'

import { ImportUtilityModel } from '../../typings'
import { useFieldOptionsData } from '../../hooks/useFieldOptionsData'
import { useHandlers } from './usehandlers'
import { useData } from '../hooks/useData'
import { useEffect } from 'react'
import { toast } from '@sales-center/components'
import CircularProgress from '@mui/material/CircularProgress'

export function PendingLeadFields() {
  const { values } = useFormikContext<ImportUtilityModel>()

  const { loading, fail } = useData()

  const { allSalesTeams, salesFunnels } = useFieldOptionsData(values)

  const { onChangeSalesTeam, onChangeSalesFunnel } = useHandlers()

  useEffect(() => {
    if (fail) {
      toast.error('Unable to retrieve Import Lookup data.')
    }
  }, [fail])

  return (
    <Box mb={5}>
      {loading ? (
        <>
          <Box pt={4.8} textAlign="center">
            <CircularProgress />
          </Box>
        </>
      ) : (
        <>
          <TypeCommonFields />
          <Grid mt={0.1} container spacing={2}>
            <Grid item xs={12}>
              <SalesTeamSelect
                name="salesTeamId"
                label="Sales Team"
                optionList={allSalesTeams}
                onChange={onChangeSalesTeam}
                disabled={false}
                required={false}
              />
            </Grid>
            <Grid item xs={12}>
              <SalesFunnelSelect
                name="salesFunnelId"
                label="Sales Funnel"
                salesFunnels={salesFunnels}
                disabled={false}
                onChange={onChangeSalesFunnel}
                required={false}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  )
}
